class Header {
  constructor() {
    this.headerDrawerToggle = document.querySelector(
      '[data-header-drawer-toggle]',
    );
    this.searchModalToggle = document.querySelector(
      '[data-search-modal-toggle]',
    );
    this.cartDrawerToggle = document.querySelector('[data-cart-drawer-toggle]');
    this.cartCount = document.querySelector('[data-cart-count]');

    this.init();
    this.setupCartUpdateListener();
  }

  init() {
    if (this.headerDrawerToggle) {
      this.headerDrawerToggle.addEventListener('click', () => {
        // TODO: Implement header drawer toggle
      });
    }

    if (this.searchModalToggle) {
      this.searchModalToggle.addEventListener('click', () => {
        // TODO: Implement search modal toggle
      });
    }

    if (this.cartDrawerToggle) {
      this.cartDrawerToggle.addEventListener('click', () => {
        // TODO: Implement cart drawer toggle
      });
    }
  }

  setupCartUpdateListener() {
    if (
      typeof subscribe === 'undefined' ||
      typeof PUB_SUB_EVENTS === 'undefined'
    )
      return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      this.updateCartCount(event.cartData);
    });
  }

  updateCartCount(cartData) {
    const cartCountElements = document.querySelectorAll('[data-cart-count]');
    if (!cartCountElements.length) return;

    let itemCount = 0;

    // Try to get item_count from cartData directly (from cart updates)
    if (cartData && typeof cartData.item_count !== 'undefined') {
      itemCount = cartData.item_count;
    }
    // If not available, try to get from items array length (from add to cart)
    else if (cartData && cartData.items && Array.isArray(cartData.items)) {
      itemCount = cartData.items.reduce(
        (total, item) => total + item.quantity,
        0,
      );
    }
    // Last resort: fetch current cart state
    else {
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          cartCountElements.forEach((element) => {
            element.textContent = cart.item_count || 0;
          });
        })
        .catch(() => {
          // Silently fail, count will update on next cart interaction
        });
      return;
    }

    cartCountElements.forEach((element) => {
      element.textContent = itemCount;
    });
  }
}

customElements.define(
  'header-component',
  class extends HTMLElement {
    connectedCallback() {
      new Header();
    }
  },
);
